(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["careers-content"]) return;
  try {
    

  $('.CareersPage-jobHead').click(function(){
    let jobBtn = $(this).find('.CareersPage-jobBtn');

    if(jobBtn.hasClass('closed')){
      jobBtn.removeClass('closed').addClass('open');
      $(this).closest('.CareersPage-job').find('.CareersPage-jdWrap').slideDown();
       $(this).closest('.CareersPage-job').siblings('.CareersPage-job').find('.CareersPage-jdWrap').slideUp();
       $(this).closest('.CareersPage-job').siblings('.CareersPage-job').find('.CareersPage-jobBtn').removeClass('open').addClass('closed');
    }else{
      jobBtn.removeClass('open').addClass('closed');
      $(this).closest('.CareersPage-job').find('.CareersPage-jdWrap').slideUp();
      $(this).closest('.CareersPage-job').siblings('.CareersPage-job').find('.CareersPage-jdWrap').slideUp();
      $(this).closest('.CareersPage-job').siblings('.CareersPage-job').find('.CareersPage-jobBtn').removeClass('open').addClass('closed');
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["localization-dropdown"]) return;
  try {
    

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-waitlist"]) return;
  try {
    
 $('#PriceEqual-video').click(function(){
    $('#PriceEqual-video').pause();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["podcast-template"]) return;
  try {
    

    $('.Podcast-btn').click(function(){
      $(this).closest('.Podcast-epListItem').find('.Podcast-epDesc').slideToggle();
      $(this).toggleClass('hide');
      if ( $(this).hasClass('hide') ){
        $(this).text('+');
      }else{
        $(this).text('–');
      }
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar-ca"]) return;
  try {
    
  $('.PromoBar2-btn').click(function(e){
    $('.PromoBar2-link.show').removeClass('show').addClass('hide').siblings('.PromoBar2-link').removeClass('hide').addClass('show');
  });
  if( $('.PromoBar2-link').length > 1 && $('.PromoBar').data('fading') === true ){
  (function myLoop(i) {
      setTimeout(function() {
         $('.PromoBar2-link.show').removeClass('show').addClass('hide').siblings('.PromoBar2-link').removeClass('hide').addClass('show');             
        if (--i) myLoop(i);   //  decrement i and call myLoop again if i > 0
      }, 6000)
    })(5);     

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar"]) return;
  try {
    
  $('.PromoBar1-btn').click(function(e){
    $('.PromoBar1-link.show').removeClass('show').addClass('hide').siblings('.PromoBar1-link').removeClass('hide').addClass('show');
  });
  if( $('.PromoBar1-link').length > 1 && $('.PromoBar').data('fading') === true ){
  (function myLoop(i) {
      setTimeout(function() {
         $('.PromoBar1-link.show').removeClass('show').addClass('hide').siblings('.PromoBar1-link').removeClass('hide').addClass('show');             
        if (--i) myLoop(i);   //  decrement i and call myLoop again if i > 0
      }, 6000)
    })(5);     

  }

  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.js-promo-modal-trigger');
    if (trigger) {
      e.preventDefault();
      const modal = document.getElementById('promoBarModal');
      modal.querySelector('.js-modal-title').innerHTML = trigger.dataset.title;
      modal.querySelector('.js-modal-content').innerHTML = trigger.dataset.content;
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      return;
    }

    if ( e.target.closest('.custom-modal__close') || e.target.classList.contains('custom-modal__overlay')) {
      const modal = document.getElementById('promoBarModal');
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const modal = document.getElementById('promoBarModal');
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-template"]) return;
  try {
    

$('.CollectionTypesNav-link').click(function(e) {
  e.preventDefault();
  let the_link = $(this).attr('href');
  let the_offset = $(the_link).offset().top;
  //alert(the_offset);
  the_offset = the_offset - 90;
  $('html, body').animate({
    scrollTop: the_offset
  }, 500);
  $(this).closest('.CollectionTypesNav-item').addClass('is-active').siblings('li').removeClass('is-active');
});

$('.RewardsFaq-item').click(function(){
  $(this).find('p').slideToggle('fast');
  $(this).find('p').toggleClass('open');
  if( $(this).find('p').hasClass('open')  ){
    console.log('hidden');
      $(this).find('.RewardsFaq-btn').text('–');
  }else{
    console.log('not hidden');
    $(this).find('.RewardsFaq-btn').text('+');
    
  }
});
setTimeout(function(){ 
  $('.lion-tier-box--current').find('.lion-tier-box__position').show(); 
  //let the_status =  $('.lion-tier-box--current').find('.lion-tier-box__title').text();


}, 500);





  } catch(e) { console.error(e); }
})();
})();
